

























































































































import { computed, defineComponent, ref, useContext, useRoute } from '@nuxtjs/composition-api';
import AddToCart from '~/components/solepro/AddToCart.vue';
import ClientOnly from 'vue-client-only';
import Teleport from 'vue2-teleport';
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS } from '~/utils/constants/product';
import accessibility from '~/utils/solepro/accessibility';
import { GenericObjectType } from '~/utils/types';

/** TODO centralizzare i metodi anche per il bundle */
export default defineComponent({
    components: {
        AddToCart,
        ClientOnly,
        Teleport,
        CrossSellItem: () => import('~/components/solepro/ProductPage/PurchaseOptions/CrossSellItem.vue')
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        },
        priceLabels: {
            required: true,
            type: Array as PropType<string[]>
        },
        frequency: {
            type: String
        },
        productConfiguration: {
            type: Object as PropType<{ [sku: string]: { [optionId: string]: string } }>,
            required: true
        },
        modulesSkus: {
            type: Object as PropType<GenericObjectType>,
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg'),
            crossSellAddQueue: [] as { sku: string, tipoAbbonamento: string | null }[],
            crossSellEndResolvers: {} as { [sku: string]: (success: boolean) => void },
            crossSellAdding: false
        }
    },
    setup(props) {
        const sanitizedSku = props.product.sku.replace(/\./g, '').replace(/ /g, '-');
        const modalId = 'cross-sell-modal-' + sanitizedSku;
        const usedModalId = ref(modalId);
        const { app, $fc } = useContext();
        const { i18n } = app;
        const addingBtnKey = ref();
        const tmp = {}

        const route = useRoute();
        const utmCampaign = computed(() => route.value.query.utm_campaign as string);
        const tipoConsegna = ref(); /**@TODO */
        const crossSellSelected = ref([]);
        const isEmptySubtitle = (modalSubtitle) => {
            return !modalSubtitle || modalSubtitle == ''
        }
        const getModalSubtitle = item => {
            item = item.product ?? item;
            let modalSubtitle = item?.box_description;
            if (isEmptySubtitle(modalSubtitle)) {
                const shortDescription = !!item.shortDescription ? item.shortDescription?.html : item.short_description?.html;
                modalSubtitle = shortDescription
                if (shortDescription && !shortDescription.hasOwnProperty('html')) {
                    modalSubtitle = shortDescription;
                }
            }
            return modalSubtitle

        }
        return {
            sanitizedSku,

            utmCampaign,
            ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS,
            tipoConsegna,
            crossSellSelected,
            getModalSubtitle,
            modalId,
            usedModalId,
            i18n,
            modulesSkusProp: props.modulesSkus as GenericObjectType,
            addingBtnKey
        }
    },
    mounted() {
        this.$nextTick(() => { //necessario per l'attesa del mounted di clientonly

            const modal = /*this.inCarousel ? */document.getElementById(this.modalId) /*: this.$refs.configureModal */as HTMLElement;
            //const closeBtns = modal.querySelectorAll('.js-close-accessible-dialog');
            const overlay = document.getElementById('modal-backdrop');

            const closeModal = this.closeModal;
            overlay.addEventListener("click", (e) => {
                // @ts-ignore
                closeModal(false)
            })

            modal.addEventListener("keydown", (evt) => {
                if (evt.key === "Escape") {
                    // @ts-ignore
                    closeModal(false);
                }
            });
        })
    },
    methods: {
        openModal(evt, modalId?: string) {
            this.usedModalId = modalId || this.modalId;
            const modal = document.getElementById(this.usedModalId)
            const overlay = document.getElementById('modal-backdrop');
            // Add overlay before modal
            overlay.classList.remove('hidden');
            document.body.classList.add('modal-open');

            // Show modal
            modal.classList.add('show');

            setTimeout(() => {
                accessibility.simpleFocusTrap(modal)
            }, 500);
        },
        closeModal(keepOverlay: Boolean) {
            this.addingBtnKey = null;
            this.crossSellAdding = false;
            const modal = document.getElementById(this.usedModalId);
            const overlay = document.getElementById('modal-backdrop');
            if (!modal) return;
            modal.classList.remove('show');

            if (!keepOverlay) overlay.classList.add('hidden');
            document.body.classList.remove('modal-open');

        },
        onCrossSellAddToCartEnd(sku, success) {
            const resolve = this.crossSellEndResolvers[sku];
            if (resolve) {
                delete this.crossSellEndResolvers[sku];
                resolve(success);
            }
        },
        triggerCrossSellAddToCart(sku) {
            return new Promise(resolve => this.clickCrossSellAddToCart(sku, resolve));
        },
        async checkCrossSells() {
            if (this.crossSellSelected.length > 0) {
                const items = this.crossSellSelected.map(p => ({
                    sku: p.sku,
                    tipoAbbonamento: (p.paymentFrequencies.includes(this.frequency)) ? this.i18n.t(`payment_frequency_${this.frequency}`) as string : (
                        p.paymentFrequencies.length > 0 ? this.i18n.t(`payment_frequency_${p.paymentFrequencies[0]}`) as string : null
                    )
                }));
                this.crossSellAddQueue = items;
                await this.$nextTick();
                try {
                    await Promise.all(items.map(item => this.triggerCrossSellAddToCart(item.sku)));
                } finally {
                this.crossSellAdding = false;
                this.addingBtnKey = null;
                }
            }
            this.closeModal(true);
        },
        async clickCrossSellAddToCart(sku, resolve) {
            const refs = this.$refs.crossSellAddToCart as any;
            const instances = Array.isArray(refs) ? refs : (refs ? [refs] : []);
            const el = instances[this.crossSellAddQueue.findIndex(csp => csp.sku === sku)];
            if (!el) {
                resolve(false);
                return;
            }
            let attempts = 0;
            while (attempts < 100 && !el.productForCart) {
                await new Promise(r => setTimeout(r, 50));
                attempts++;
            }
            if (!el.productForCart || el.isDisabled) {
                console.error('Cross sell product cannot be added to cart', sku);
                resolve(false);
                return;
            }
            this.crossSellEndResolvers[sku] = resolve;
            el.$el.click();
        },
        setCrossSellElement(evt) {
            if (evt.isAdded) {
                this.crossSellSelected.push(evt.product)
            } else {
                const index = this.crossSellSelected.findIndex(el => el.sku == evt.product.sku)
                if (index > -1) {
                    this.crossSellSelected.splice(index, 1)
                }
            }
        },

    }
})
